/* eslint eqeqeq: 0 */

import moment from "moment";
import { getDate } from "./dateParser";
import { isJSON } from "./isJson";
import { sessionService } from "../services/session";

export function substractObjects(source, dest) {
  let difference = {};

  if (typeof source == "object") {
    //&& typeof dest == "object")   //&& !(source instanceof Array
    for (const key in source) {
      if (typeof source[key] == "object") {
        // && !(source[key] instanceof Array))
        let diff = substractObjects(source[key], !dest || dest == undefined ? {} : dest[key]);
        if (diff != {}) {
          difference[key] = source[key] instanceof Array ? [] : {};
          difference[key] = Object.assign(source[key] instanceof Array ? [] : {}, diff);
        }
      } else if (!dest || dest[key] == undefined || source[key] != dest[key]) {
        difference[key] = source[key];
      }
    }
  }
  return difference;
}

export function truncateNumber(num) {
  let retNum = num;
  let checkNum = Number.isInteger(retNum);
  if (!checkNum) {
    retNum = parseFloat(retNum.toFixed(2));
  }
  return retNum;
}

/**
 *
 * @param {string} startTime Start time in string (24 hours format e.g. 23:00)
 * @param {string} endTime End time in string (24 hours format e.g. 23:00)
 * @returns {string} Time difference in string (24 hours format e.g. 23:00)
 */
export const getTimeDiffBetweenTimes = (startTime, endTime) => {
  const getTimeDiff = (start, end) => {
    let diff = (end - start) / 60000;
    let hours = diff / 60;
    let minutes = diff % 60;
    start.set("minute", minutes);
    start.set("hour", hours);
    return start.format("HH:mm");
  };

  // return null if any date is missing or invalid
  if (!endTime || !startTime) return "ERR!";

  let startDate = moment("1/1/2000 " + startTime);
  let endDate = moment("1/1/2000 " + endTime);

  if (endDate < startDate) {
    endDate.add({
      day: 1,
    });
  }

  return getTimeDiff(startDate, endDate);
};

export function isSelfUser(user) {
  let loggedInUser = isJSON(localStorage.getItem("loggedInUser"));
  return user && loggedInUser && user.email === loggedInUser.email;
}

export function decodeGtAndLt(str) {
  if (!str) return str;
  return str.replace(/&gt;/g, ">").replace(/&lt;/g, "<");
}

export const sanitizedFilename = (filename) => {
  return typeof filename === "string" ? filename.replace(/[/\\?%*:|"<>#]/g, "_") : filename;
};
export function validOrZero(s) {
  return s || s === 0;
}

export function validOrZeroOrString(s) {
  return s || s === 0 || typeof s === "string";
}

export const fetchStaticResource = async (url) => {
  try {
    const token = sessionService.getToken() || localStorage.getItem("access_token");
    if (!token) throw new Error("No authentication token found");

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: token,
      },
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch: ${response.status} ${response.statusText}`);
    }

    const blob = await response.blob();
    return URL.createObjectURL(blob);
  } catch (error) {
    console.error("Error fetching resource:", error);
    return null;
  }
};



// WEBPACK FOOTER //
// ./src/utils/utils.js